import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type UserPointOwner = {
  pointOwnerId: number;
  userId: string;
  ownerType: "user" | "child";
  ownerName: string;
  ownerBirthday: string | null;
  iconType: string | null;
  displayOrder: number;
  currentPoint: number;
  availableGiftPoint: number;
  supportedPoint: number;
  increasedPoint: number;
  totalPoint: number;
  createdAt: string;
  updatedAt: string | null;
};

export type PostUserPointOwnerChildParam = {
  childName: string;
  birthday: string;
  iconType: string;
};

const childUri = "api/users/point-owners/children";
const uri = "api/users/point-owners";

export const fetchUserPointOwnersAtom = atom<State<UserPointOwner> | null>(null);

export const postUserPointOwnerChildAtom = atom<State<UserPointOwner> | null>(null);

export const fetchUserPointOwners = () => {
  return fetchBase<UserPointOwner>(uri, fetchUserPointOwnersAtom);
};

export const postUserPointOwnerChild = () => {
  return postBase<UserPointOwner, PostUserPointOwnerChildParam>(
    childUri,
    postUserPointOwnerChildAtom
  );
};
